import { render, staticRenderFns } from "./sku_profit.vue?vue&type=template&id=1564e06c&scoped=true&"
import script from "./sku_profit.vue?vue&type=script&lang=js&"
export * from "./sku_profit.vue?vue&type=script&lang=js&"
import style0 from "./sku_profit.vue?vue&type=style&index=0&id=1564e06c&scoped=true&lang=css&"
import style1 from "./sku_profit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564e06c",
  null
  
)

export default component.exports